import { Badge } from '@/components/sv/badge'
import { cn } from '@/lib/utils'
import type { ProcessResourceCategory } from '@/graphql.types'

const getBadgeVariant = (category: ProcessResourceCategory | undefined) => {
  switch (category) {
    case 'hobby':
      return 'emerald'
    case 'standard':
      return 'sky'
    case 'cpuOptimized':
      return 'purple'
    case 'memoryOptimized':
      return 'pink'
    default:
      return 'default'
  }
}

type Props = {
  category?: ProcessResourceCategory
  name?: string
  className?: string
}

export const ProcessBadge = ({ category, name, className }: Props) => {
  if (!category || !name) {
    return null
  }

  return (
    <Badge
      variant={getBadgeVariant(category)}
      className={cn('w-8 uppercase', className)}
    >
      {name}
    </Badge>
  )
}
